/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Routemize_DTOs_ReferralProgramDto } from '../models/Routemize_DTOs_ReferralProgramDto';
import type { Routemize_DTOs_UpdatePayPalEmailDto } from '../models/Routemize_DTOs_UpdatePayPalEmailDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ReferralService {
    /**
     * @returns Routemize_DTOs_ReferralProgramDto OK
     * @throws ApiError
     */
    public static getApiAppReferralGetMyReferralProgram(): CancelablePromise<Routemize_DTOs_ReferralProgramDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/referral/getMyReferralProgram',
        });
    }
    /**
     * @returns Routemize_DTOs_ReferralProgramDto OK
     * @throws ApiError
     */
    public static postApiAppReferralEnroll(): CancelablePromise<Routemize_DTOs_ReferralProgramDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/referral/enroll',
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static putApiAppReferralUpdatePayPalEmail(
        requestBody?: Routemize_DTOs_UpdatePayPalEmailDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/app/referral/updatePayPalEmail',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
